import CM from '@emersya/mpa-components-manager-lib';

export interface IFrameComponentConfiguration extends CM.DOMComponent.IConfiguration {
	URL? : string | null;
};

export abstract class FrameComponent<
	TNode extends HTMLElement | null,
	TComponent extends FrameComponent<TNode, TComponent, TConfiguration>,
	TConfiguration extends IFrameComponentConfiguration,
> extends CM.DOMComponent<
	TNode,
	TComponent,
	TConfiguration
>
{
	static override initialize() {
		CM.Component.initialize.call(this);
		this.declareEventType('loading', 'beforeLoad');
		this.declareEventType('loading', 'load');
		this.declareEventType('loading', 'beforeUnload');
		this.declareEventType('loading', 'unload');
	};

	URL : string | null = null;
	window : Window | null = null;

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : TConfiguration
	)
	{
		super(descriptor, configuration);
		if (configuration.URL) {
			this.URL = configuration.URL;
		}
	};
};
export namespace NS {
	export const Component = FrameComponent;
	export type Component<
		X extends HTMLElement | null,
		Y extends FrameComponent<X, Y, Z>,
		Z extends IFrameComponentConfiguration
	> = FrameComponent<X, Y, Z>;
	export type Configuration = IFrameComponentConfiguration;
}
;
CM.declareAbstract({
	id :   'frame',
	type : <any> FrameComponent
});
